// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shimmer skeleton — consumers opt in independently from the token contract. */
.animate-shimmer {
  background: linear-gradient(
    90deg,
    hsl(var(--muted)) 25%,
    hsl(var(--muted-foreground) / 0.06) 50%,
    hsl(var(--muted)) 75%
  );
  background-size: 200% 100%;
  animation: shimmer var(--component-shimmer-duration) ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .animate-shimmer {
    animation-duration: var(--component-shimmer-reduced-duration);
  }

  .specra-spinner {
    animation-duration: var(--component-spinner-reduced-duration);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-components/src/styles/specra-behaviors.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,yEAAyE;AAC3E;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;AACF","sourcesContent":["/* Shimmer skeleton — consumers opt in independently from the token contract. */\n.animate-shimmer {\n  background: linear-gradient(\n    90deg,\n    hsl(var(--muted)) 25%,\n    hsl(var(--muted-foreground) / 0.06) 50%,\n    hsl(var(--muted)) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer var(--component-shimmer-duration) ease-in-out infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .animate-shimmer {\n    animation-duration: var(--component-shimmer-reduced-duration);\n  }\n\n  .specra-spinner {\n    animation-duration: var(--component-spinner-reduced-duration);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
